<template>
  <div class="container-fluid">
    <div class="page-tabs">
      <a
        v-for="(item, index) in tabOptions"
        :key="item.index"
        :class="{ active: currentTab === index }"
        @click.prevent="currentTab = index"
        href="#"
      >
        {{ item.title }}
      </a>
    </div>
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">
                {{ currentTab === 0 ? "一階選項類別" : "二階選項類別" }}</label
              >
              <el-select
                class="w-100"
                filterable
                :clearable="false"
                v-model="messageType"
                placeholder="請選擇"
              >
                <el-option
                  v-for="hierarchy in hierarchyOptions"
                  :key="hierarchy.Key"
                  :label="hierarchy.Value"
                  :value="hierarchy.Key"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-if="this.messageType" class="col-sm-12 col-md-3">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              @click="(action = 'add'), openModal()"
            >
              {{ i18n("Buttons.Add") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--table -->
    <div class="yahome-table-wrap">
      <VueTreeGrid
        :key="treeKey"
        :columns="columns"
        :tree="tree"
        emptyText="暫無資料"
        @expand="expandMenu"
      >
        <template slot="sort--row-cell" slot-scope="scope">
          <div class="text-center">
            <button
              v-if="scope.row._index !== 0"
              class="btn btn btn-outline-secondary btn-sm"
              @click="changeSort({ item: scope.row, action: 'up' })"
            >
              <i class="fas fa-long-arrow-alt-up" />
            </button>
            <!-- {{ scope.row }} -->
            <span v-if="scope.row._level === 1">
              <button
                v-if="scope.row._index !== tree.length - 1"
                class="btn btn btn-outline-secondary btn-sm"
                @click="changeSort({ item: scope.row, action: 'down' })"
              >
                <i class="fas fa-long-arrow-alt-down" />
              </button>
            </span>
            <span v-if="scope.row._level === 2">
              <button
                v-if="scope.row._index !== scope.row.childrenLength - 1"
                class="btn btn btn-outline-secondary btn-sm"
                @click="changeSort({ item: scope.row, action: 'down' })"
              >
                <i class="fas fa-long-arrow-alt-down" />
              </button>
            </span>
          </div>
        </template>
        <template slot="switch--row-cell" slot-scope="scope">
          {{ scope.row.IsEnable ? "是" : "否" }}
        </template>
        <template slot="action--row-cell" slot-scope="scope">
          <button
            v-if="currentTab === 1 && scope.row._level === 1"
            type="button"
            class="btn btn-primary btn-sm"
            @click="(action = 'add'), openModal(scope.row)"
          >
            {{ i18n("Buttons.Add") }}
          </button>
          <button
            type="button"
            class="btn btn-info btn-sm"
            @click="(action = 'edit'), openModal(scope.row)"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
          <el-popconfirm
            v-if="scope.row._childrenLength === 0"
            confirm-button-text="確定"
            cancel-button-text="取消"
            title="確定刪除？"
            @confirm="delMessage(scope.row)"
          >
            <button
              type="button"
              class="btn btn-danger btn-sm"
              slot="reference"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </el-popconfirm>
        </template>
      </VueTreeGrid>
    </div>

    <!-- 新增&編輯 Modal -->
    <div
      class="modal fade"
      id="cannedModal"
      tabindex="-1"
      data-backdrop="static"
      data-focus="false"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="canned"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="action === 'add'">新增訊息</span>
              <span v-else>編輯訊息</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider
                  rules="required"
                  tag="div"
                  v-slot="{ errors }"
                >
                  <label for="edit-name">
                    <span class="mark">*</span>
                    訊息文字
                  </label>
                  <el-input
                    v-model="cannedMessage.Name"
                    maxlength="200"
                    clearable
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div v-if="action === 'edit'" class="form-group">
                <ValidationProvider
                  rules="required"
                  tag="div"
                  v-slot="{ errors }"
                >
                  <label for="edit-name">
                    <span class="mark">*</span>
                    是否啟用
                  </label>
                  <el-select
                    class="w-100"
                    placeholder="請選擇"
                    v-model="cannedMessage.IsEnable"
                  >
                    <el-option label="是" :value="true" />
                    <el-option label="否" :value="false" />
                  </el-select>
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveMessage)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import VueTreeGrid from "@reallife/vue-tree-grid";

export default {
  name: "CannedLetter",

  components: {
    VueTreeGrid,
  },
  data() {
    return {
      // tab
      tabOptions: [{ title: "一階" }, { title: "二階" }],
      currentTab: 0,

      // 階層
      hierarchyOptions: [],
      messageType: null,

      // 樹狀選單table
      treeKey: 0,
      tree: [],
      treePath: null,
      columns: [
        {
          type: "prop",
          prop: "sort",
          width: "8%",
        },
        {
          label: "訊息文字",
          type: "prop",
          prop: "Name",
          width: "25%",
        },
        {
          label: "是否啟用",
          type: "prop",
          prop: "switch",
          width: "15%",
        },
        {
          type: "prop",
          prop: "action",
          label: "",
          width: "10%",
        },
      ],

      // 主選單名稱
      ParentName: null,
      editTemp: {},

      action: "edit",
      cannedMessage: {},
    };
  },

  methods: {
    // 取得 罐頭訊息
    getMessage(type) {
      this.updateLoading(true);
      this.$api.defaultMessage.getCannedLetterList(type).then((response) => {
        if (response.status === 200) {
          let tree = [];
          this.treeKey++;
          response.data.forEach((item) => {
            let data = {
              ...item,
              children: item.Children,
              _isExpanded: false,
            };
            data.children.forEach((item) => {
              item.childrenLength = data.children.length;
            });
            tree.push(data);
          });

          this.tree = tree;
          if (this.treePath && this.tree[this.treePath]) {
            this.tree[this.treePath]._isExpanded = true;
          }

          this.tableData = response.data.map((item) => {
            return {
              MenuGuid: item.Guid,
              MenuName: item.MenuName,
              Children: item.Children.map((item) => {
                return {
                  MenuGuid: item.Guid,
                  MenuName: item.MenuName,
                };
              }),
            };
          });
        }
        this.updateLoading(false);
      });
    },

    // 新增 & 編輯 Modal
    openModal(data) {
      if (this.action === "add") {
        this.cannedMessage = {
          ParentGuid: data ? data.Guid : null,
          MessageType: this.messageType,
        };
      } else {
        this.cannedMessage = {
          Guid: data.Guid,
          Name: data.Name,
          IsEnable: data.IsEnable,
        };
      }
      this.$refs.canned.reset();
      $("#cannedModal").modal("show");
    },

    // 儲存
    saveMessage() {
      $("#cannedModal").modal("hide");
      this.updateLoading(true);
      let api =
        this.action === "add" ? "postDefaultMessage" : "putDefaultMessage";
      this.$api.defaultMessage[api](this.cannedMessage).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: this.action === "add" ? "新增成功" : "編輯成功",
            type: "success",
            duration: 2000,
          });
          this.getMessage(this.messageType);
        }
        this.updateLoading(false);
      });
    },

    // 刪除
    delMessage(data) {
      this.updateLoading(true);
      this.$api.defaultMessage.delDefaultMessage(data.Guid).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 2000,
          });
          this.getMessage(this.messageType);
        }
        this.updateLoading(false);
      });
    },

    // 排序
    changeSort({ item, action }) {
      this.updateLoading(true);
      this.$api.defaultMessage
        .postSort({
          Guid: item.Guid,
          Turn: action,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "排序變更成功",
              type: "success",
              duration: 2000,
            });
            this.getMessage(this.messageType);
          }
          this.updateLoading(false);
        });
    },

    // 延續展開 罐頭清單
    expandMenu(row) {
      this.treePath =
        this.treePath === Number(row._path) ? null : Number(row._path);
    },

    async getData() {
      const hierarchy = await this.$api.defaultMessage.getHierarchy(1);
      // 取得 階層選項
      this.hierarchyOptions = hierarchy.data;
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  watch: {
    currentTab: async function (newVal) {
      let hierarchy;
      this.messageType = null;
      this.hierarchyOptions = [];
      this.tree = [];
      this.treePath = null;
      this.treeKey = 0;
      if (newVal === 0) {
        hierarchy = await this.$api.defaultMessage.getHierarchy(1);
      } else {
        hierarchy = await this.$api.defaultMessage.getHierarchy(2);
      }
      this.hierarchyOptions = hierarchy.data;
    },

    messageType: async function (newVal) {
      if (newVal) {
        this.getMessage(newVal);
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
i.tree-grid__expand-icon {
  background-color: #4062c2 !important;
  border-radius: 50% !important;
  color: #fff;
  line-height: 17px !important;
  width: 20px !important;
  height: 20px !important;
  margin-left: -20px;
  font-style: normal;

  &.tree-grid__expand-icon--expanded {
    background-color: #e55353 !important;
  }
}

.tree-grid__body-cell {
  .btn {
    margin-right: 5px;
  }
}

.el-collapse-header {
  .el-collapse-item__header {
    font-size: 16px;
  }
}
</style>
